import { render } from "./FirstStepsContainer.vue?vue&type=template&id=630f89df&scoped=true"
import script from "./FirstStepsContainer.vue?vue&type=script&lang=js"
export * from "./FirstStepsContainer.vue?vue&type=script&lang=js"

import "./FirstStepsContainer.vue?vue&type=style&index=0&id=630f89df&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-630f89df"]])

export default __exports__